import NotFound from '@/templates/NotFound';
// import NotFound1 from '@/components/notFound/notFound';

export default [
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
    meta: {
      title: 'No encontrado',
      layout: NotFound,
      isSlim: true,
    },
  },
];
